// ROOT-only full-system backup. The archive is built by a background job, so
// most of these strings name a job state rather than a screen.
import { formatNumber } from '../../utils/format-number'

import { BACKGROUND_JOB } from './background-job'
import { COMMON } from './common'
import { NAV } from './nav'

/** What stops a backup from starting or finishing. */
export const BACKUP_ERRORS = {
  alreadyRunning: (live: number) =>
    BACKGROUND_JOB.alreadyRunning(live, 'ein Backup'),
  startFailed: 'Backup konnte nicht gestartet werden',
} as const

export const BACKUP = {
  title: NAV.backup,
  subtitle:
    'Die gesamte Datenbank als pg_dump, dazu alle Medien, Projektbilder und Projektdokumente in einem Archiv. Gedacht für den Desaster-Fall. Läuft als Hintergrund-Job — die Seite kann geschlossen werden, das Archiv liegt danach hier zum Download bereit.',

  start: {
    title: 'Neues Backup',
    description:
      'Erzeugt ein neues Archiv und ersetzt damit das vorhandene. Je nach Datenmenge dauert das einige Minuten.',
    action: 'Backup starten',
    replaceTitle: 'Vorhandenes Backup ersetzen?',
    replaceMessage:
      'Das aktuelle Archiv wird gelöscht, sobald das neue fertig ist. Lade es vorher herunter, falls du es behalten willst.',
    confirm: 'Backup starten',
  },

  running: {
    title: BACKGROUND_JOB.running,
    stage: {
      database: 'Datenbank wird gesichert',
      files: 'Dateien werden gesichert',
      finish: 'Archiv wird abgeschlossen',
    },
    // What a sweep will find is not known until it has found it, so this
    // counts rather than pretending to a fraction.
    progress: (files: number) =>
      files === 1
        ? '1 Datei gesichert'
        : `${formatNumber(files)} Dateien gesichert`,
    failed: 'Backup fehlgeschlagen',
  },

  archive: {
    title: 'Bereitliegendes Archiv',
    loadError:
      'Der Status konnte nicht geladen werden. Ob ein Archiv bereitliegt, ist gerade unbekannt.',
    none: 'Es liegt kein Backup bereit.',
    noneHint: 'Starte einen Lauf, um eines zu erzeugen.',
    size: COMMON.size,
    download: COMMON.download,
    expiryHint: (days: number) =>
      `Wird nach ${days} Tagen automatisch gelöscht. Verwahre es außerhalb des Systems.`,
    delete: 'Archiv löschen',
    deleteTitle: 'Archiv löschen?',
    deleteMessage:
      'Das Archiv wird sofort aus dem Speicher entfernt. Lade es vorher herunter, falls du es noch brauchst — zurückholen lässt es sich nicht.',
    deleteFailed: 'Archiv konnte nicht gelöscht werden',
  },

  contents: {
    title: 'Was drin ist',
    database:
      'Gesamte Datenbank, als pg_dump — einmal im Custom-Format für pg_restore, einmal als lesbares SQL',
    media: 'Medienbibliothek: Originale und Derivate',
    projectImages: 'Projektbilder',
    projectDocuments: 'Projektdokumente samt Thumbnails',
    advisors: 'Berater-Portraits',
    excluded: 'Nicht enthalten',
    excludedListings:
      'Objekt- und Match-Bilder: der größte Bestand und über den Listing-Import jederzeit nachladbar. Die zugehörigen Datensätze sind im Dump enthalten, die Bilddateien nicht.',
    excludedSecrets:
      'Zugangsdaten und Konfiguration: ein herunterladbares Archiv ist der falsche Ort dafür.',
  },
} as const
